<template>
  <div
    class="f360-screen-frame"
    :class="{
      'f360-screen-frame--fill': fill,
      'f360-screen-frame--interactive-table': interactiveTable
    }"
  >
    <div class="f360-screen-frame__basecontent">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  fill?: boolean;
  interactiveTable?: boolean;
}>();
</script>

<style lang="scss" scoped>
.f360-screen-frame {
  display: flex;
  flex-direction: column;
  gap: var(--prisma-space-sm);

  &__basecontent {
    background: #fff;
    padding: 8px 15px;
    border-radius: 5px;
    margin: 7px 0 0;
    height: auto;
  }

  &--fill {
    flex: 1;
    min-height: 0;

    .f360-screen-frame__basecontent {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }
  }

  &--interactive-table {
    :deep(.p-table) {
      --prisma-table-row-hover-bg-color: var(--prisma-color-primary-light-8);
    }

    :deep(.prisma-table--enable-row-hover .prisma-table__body tr:hover > td),
    :deep(.prisma-table__body tr.hover-row > td),
    :deep(.p-table__row:hover > td),
    :deep(.p-table__row.hover-row > td) {
      background-color: var(--prisma-color-primary-light-8) !important;
    }
  }
}

:global(body.financas-sticky-page-context .common-layout-main),
:global(body.financas-sticky-page-context .financas-main) {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: clip;
  overflow-y: visible;
}
</style>
